import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_service/auth.service';
import { Router } from '@angular/router';
import { AlertifyService } from '../_service/alertify.service';
import { MatDialog } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ForgotpasswordComponent } from '../forgotpassword/forgotpassword.component';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: "login",
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  hide = true;
  model: any = {};
  sdsloginForm: FormGroup;
  decodedToken: any;
  inValidLogin: any = [];
  inValidDBUser: any = [];
  validLogin: any = [];
  userLockedOut: any = [];
  jwtHelper = new JwtHelperService();
  response: any = {};

  constructor(
    public authService: AuthService,
    private router: Router,
    private alertify: AlertifyService,
    private dialog: MatDialog,
    public fb: FormBuilder,
  ) {
    this.sdsloginForm = fb.group({
      emailFormControl : new FormControl('', [
        Validators.required,
        Validators.email,
        this.WhitespaceValidator,
        Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
      ]),
      passwordFormControl : new FormControl('', [
        Validators.required,
        this.WhitespaceValidator,
        Validators.maxLength(20),
        Validators.minLength(6)
      ])
    });
  }

  ngOnInit() {
    if (localStorage.getItem('token') != null) {
      this.router.navigateByUrl('/search');
    }
  }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getUserEmail() {
    if (this.response) {
      this.decodedToken = this.jwtHelper.decodeToken(this.response.body.token);
      return this.decodedToken;
    } else {
      return null;
    }
  }

  login() {
    this.model.email = this.sdsloginForm.get('emailFormControl').value;
    this.model.password = this.sdsloginForm.get('passwordFormControl').value;
    this.authService.login(this.model);
  }

  loggedIn() {
    const token = localStorage.getItem('token');
    return !!token;
  }

  loggedInWindowsUser() {
    const token = localStorage.getItem('token');
    return !!token;
  }

  openForgotPasswordWindow() {
    this.dialog.open(ForgotpasswordComponent, {
      width: '500px'
    });
  }
}